import { type UserSetting, type ErrorResponse } from '@soulhx/fs-common';
import { db } from '../model/db.js';
import { useAsyncLiveQuery } from './useAsyncLiveQuery.js';
import { queueLocalSettingUpdate } from '../sync/SettingSync.js';

export type BulkSettingUpdate = (updates: UserSetting[]) => void;

export interface SettingsResponse {
  settings: UserSetting[];
  settingsError?: ErrorResponse;
  settingsLoading: boolean;
  bulkUpdate: BulkSettingUpdate;
}

export const useBulkUserSettings = (): SettingsResponse => {
  const { data: settings, isLoading: settingsLoading } = useAsyncLiveQuery<UserSetting[]>(
    async () => {
      const settings = await db.settings.toArray();
      return settings;
    },
    [],
    []
  );

  const bulkUpdate = async (newSettings: UserSetting[]) => {
    for (const settingToUpdate of newSettings) {
      const current = await db.settings.get(settingToUpdate.settingId);
      if (
        current &&
        current.settingBoolValue === settingToUpdate.settingBoolValue &&
        current.settingStringValue === settingToUpdate.settingStringValue
      ) {
        continue;
      }

      await queueLocalSettingUpdate(settingToUpdate);
    }
  };

  return { settings, settingsLoading, bulkUpdate };
};
